module.exports = __webpack_public_path__ + "img/30_9.4e1f2ccb.png";